<template>
  <div class="tableData" style="font-size: 10px;">
    <!-- 标题与版本日期 -->
    <div class="title" style="margin-top: 10px; font-size: 18px; font-weight: bold; text-align: center;">
      悄然声色上传规则
    </div>
    <div style="margin-top: 5px; font-size: 12px; text-align: center; color: #666;">
      版本日期：2026年8月17日
    </div>

    <!-- 第一条 适用范围 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      第一条 适用范围
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>1.1</strong> 本规则适用于所有在悄然声色平台（以下简称“本平台”）上传声音样本、音频文件及相关内容的用户（以下简称“您”或“上传者”），包括但不限于使用声音克隆功能的用户以及在本平台声音交易市场（以下简称“市场”）中上传售卖声音产品的卖家。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>1.2</strong> 您使用本平台的上传功能，即视为已阅读、理解并同意接受本规则及《悄然声色用户服务协议》的全部约束。
    </div>

    <!-- 第二条 上传者权利声明与保证 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      第二条 上传者权利声明与保证
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>2.1 声音来源合法：</strong>您承诺并保证，您上传至本平台的全部声音样本、音频文件及相关内容（以下统称“上传内容”），其来源合法合规，不侵犯任何第三方的合法权益（包括但不限于声音权、肖像权等人格权，以及著作权、专利权、商标权等知识产权）。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>2.2 权利完整性：</strong>您保证对上传内容拥有完整且合法的所有权、使用权，或已取得权利人充分、必要且有效的书面授权。您承诺上传内容不存在任何权利瑕疵或权利纠纷。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>2.3 本人声音优先原则：</strong>如您上传的声音样本为本人声音，您须确认该声音样本为您本人真实、自然的声音。如上传的声音样本非您本人，您须依法告知被模仿或采集声音的自然人，并取得其单独、明确的书面同意。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>2.4 授权范围明确：</strong>您应清晰说明上传内容的授权范围和使用限制。如上传内容涉及商业使用，您须取得权利人明确的商用授权。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>2.5 AI合成声音的法律地位：</strong>您理解并确认，利用本平台生成的AI合成声音，如具有可识别性（即能够让社会公众联想到特定自然人），仍受《中华人民共和国民法典》关于声音权益的保护。即使声音系通过AI技术合成生成，未经声音权利人授权而使用该合成声音，仍可能构成对权利人声音权益的侵权，您应自行承担因此产生的全部法律责任。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>2.6 授权文件要求：</strong>如您上传的声音样本涉及他人声音，您应确保所取得的书面授权文件清晰载明以下内容：（1）授权主体（权利人本人）；（2）被授权主体（您本人）；（3）授权使用的具体声音样本内容；（4）授权使用的具体场景、范围及期限；（5）是否允许商业使用；（6）是否允许转授权。授权链条不完整或不清晰的，视为未取得合法授权。
    </div>

    <!-- 第三条 上传内容要求 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      第三条 上传内容要求
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6; font-weight: bold;">
      3.1 内容合法性
    </div>
    <div style="margin-top: 2px; font-size: 14px; line-height: 1.6;">
      您上传的内容不得含有以下情形：<br />
      3.1.1 违反中华人民共和国法律法规的内容；<br />
      3.1.2 含有色情、淫秽、暴力、恐怖、赌博、毒品、诈骗等信息的内容；<br />
      3.1.3 含有侮辱、诽谤、歧视、骚扰他人或侵犯他人名誉权、隐私权的内容；<br />
      3.1.4 含有虚假信息、谣言或可能误导公众的内容；<br />
      3.1.5 危害国家安全、损害国家荣誉和利益、破坏民族团结的内容；<br />
      3.1.6 其他法律法规禁止传播的内容。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6; font-weight: bold;">
      3.2 内容质量与格式要求
    </div>
    <div style="margin-top: 2px; font-size: 14px; line-height: 1.6;">
      3.2.1 上传的音频文件应音质清晰、无明显噪音或损坏。<br />
      3.2.2 上传内容应完整、可正常播放和使用。<br />
      3.2.3 上传内容应准确描述，标题、描述等信息应与实际内容相符，不得进行虚假或引人误解的描述。
    </div>

    <!-- 第四条 禁止行为 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      第四条 禁止行为
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      您在使用本平台上传功能时，严禁从事以下行为：
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>4.1 禁止上传未经授权的声音：</strong>不得上传、克隆或使用任何未经授权的他人的声音，包括但不限于明星、名人、知名配音演员、公众人物及其他任何自然人的声音。未经本人书面正式授权，严禁擅自采集、使用、合成、传播相关声纹。
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>4.2 禁止侵权克隆：</strong>不得利用本平台克隆他人声音用于冒充、欺诈、诽谤、骚扰或其他非法活动。
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>4.3 禁止上传违法内容：</strong>不得利用本服务制作、上传、复制、发布或传播任何违反法律法规的内容，包括但不限于含有色情、淫秽等违法信息的内容。
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>4.4 禁止滥用服务：</strong>不得将本服务用于窃取、泄露、转让、滥用、篡改或破坏数据、商业秘密和个人信息等行为。
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>4.5 禁止规避标识：</strong>不得移除、篡改或规避本平台在生成合成内容中添加的显式标识或隐式标识。
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>4.6 禁止竞争性使用：</strong>不得将本服务用于创建、训练或改进与本平台存在竞争关系的产品和服务。
    </div>

    <!-- 第五条 市场上传特别规定 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      第五条 市场上传特别规定
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>5.1 原创性要求：</strong>您在市场中上传售卖的声音产品须为您的原创声音，或您已取得权利人完整、合法、有效的书面授权。您不得上传售卖任何未经授权的他人声音。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>5.2 授权链条完整性：</strong>如您上传的声音产品涉及他人声音，您须确保授权链条完整、清晰、可追溯。录音制品的著作权授权不等于声音人格权授权，拥有录音制品的著作权并不意味着同时获得了声音权利人的人格权授权。您应确保就声音本身的使用已获得权利人独立、明确的人格权授权。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>5.3 持有著作权不等于可商用声音：</strong>您理解并确认，即使您拥有某一录音制品（如歌曲、有声书录音等）的著作权或使用权，该等权利并不自动包含对录音制品中所含自然人声音的独立使用权。如需将该录音制品中的声音用于声音克隆或AI合成，您仍需另行取得该声音权利人的书面授权。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>5.4 授权文件备查：</strong>如上传内容涉及他人声音或第三方权利，您应保留相关授权文件原件或复印件，并能在本平台要求时及时提供以供核验。若未能及时提供，本平台有权根据权利人的要求，对涉嫌侵权的内容采取下架、删除等措施，且不承担因此对您造成的任何损失。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>5.5 信息真实性：</strong>您应如实、准确描述声音产品的特征、用途及授权范围，不得进行虚假或引人误解的宣传。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>5.6 价格合理性：</strong>您设定的声音产品价格应合理、真实，不得利用异常定价进行洗钱等违法犯罪活动。
    </div>

    <!-- 第六条 上传审核 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      第六条 上传审核
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>6.1</strong> 本平台有权对您上传的全部内容进行审核。审核内容包括但不限于：声音来源合法性、内容合规性、格式规范性、版权合法性等。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>6.2</strong> 本平台有权根据审核结果决定是否接受您的上传内容。对于不符合本规则的内容，本平台有权拒绝发布、下架或删除。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>6.3</strong> 审核通过不代表本平台对上传内容的合法性、真实性、准确性作出任何保证，您仍须对上传内容承担全部法律责任。
    </div>

    <!-- 第七条 违规处理 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      第七条 违规处理
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      如您违反本规则的任何约定，本平台有权视情节轻重采取以下一项或多项措施：<br />
      7.1 发出警告并要求限期改正；<br />
      7.2 拒绝发布、下架或删除您上传的违规内容；<br />
      7.3 暂时或永久限制您的上传权限；<br />
      7.4 暂时或永久封禁您的账号；<br />
      7.5 冻结或扣除您账户中的交易额度及收益（如适用）；<br />
      7.6 向有关国家机关举报并移交相关证据材料；<br />
      7.7 追究您的违约赔偿责任。
    </div>

    <!-- 第八条 知识产权与授权 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      第八条 知识产权与授权
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>8.1</strong> 您上传至本平台的内容，其知识产权仍归您或权利人所有。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>8.2</strong> 您授予本平台在提供本服务所必需的范围内，对您上传的内容进行存储、复制、处理、传输和使用，包括但不限于用于声音克隆模型的训练和优化。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>8.3</strong> 本平台对您上传的内容不主张所有权，但有权依据法律法规及本规则对内容进行管理和处置。
    </div>

    <!-- 第九条 法律后果告知 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      第九条 法律后果告知
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>9.1 侵权责任：</strong>您理解并确认，未经声音权利人合法授权而擅自上传、使用、克隆、传播、售卖他人声音的，可能构成对权利人声音权益（人格权）及/或著作权的侵犯。侵权人依法可能承担以下法律责任：<br />
      （1）停止侵害、消除影响、赔礼道歉；<br />
      （2）赔偿权利人因此遭受的实际损失或侵权人因此获得的违法所得；<br />
      （3）权利人的实际损失或侵权人的违法所得难以计算的，由人民法院根据侵权行为的情节，判决给予五百万元以下的赔偿；<br />
      （4）赔偿权利人因维权而支出的合理费用，包括但不限于律师费、公证费、诉讼费等。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>9.2 司法判例参考：</strong>您理解并确认，司法实践中已有未经授权使用他人声音用于AI合成被判侵权赔偿的案例，法院认定即使声音系通过AI技术合成，如具备可识别性，仍受人格权保护，侵权人须承担相应赔偿责任。已有判例确定的赔偿金额包括但不限于25万元等数额。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>9.3 刑事责任风险：</strong>如您的行为情节严重，构成犯罪的，依法可能追究刑事责任。
    </div>

    <!-- 第十条 免责声明 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      第十条 免责声明
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>10.1</strong> 本平台仅提供声音上传、存储及克隆技术工具，不对您上传内容的合法性、真实性、准确性、完整性承担任何责任。您应对您上传的全部内容和行为独立承担全部法律责任。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>10.2</strong> 因您上传的内容侵犯第三方合法权益而引发的任何纠纷、索赔、诉讼或行政处罚，由您自行承担全部法律责任和经济损失，并应赔偿因此给本平台造成的全部损失，包括但不限于赔偿款、罚款、律师费、诉讼费、公证费、差旅费等全部合理费用。
    </div>

    <!-- 第十一条 规则的修改与生效 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      第十一条 规则的修改与生效
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>11.1</strong> 本平台有权根据法律法规变化、业务发展需要等因素适时修改本规则。修改后的规则将通过本平台官网、APP或站内通知等渠道予以公布。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>11.2</strong> 如您不同意修改后的规则，应立即停止上传内容；如您继续使用上传功能，则视为您已接受修改后的规则。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      <strong>11.3</strong> 本规则自公布之日起生效。
    </div>

    <!-- 第十二条 法律适用 -->
    <div style="margin-top: 15px; font-size: 14px; font-weight: bold;">
      第十二条 法律适用
    </div>
    <div style="margin-top: 5px; font-size: 14px; line-height: 1.6;">
      <strong>12.1</strong> 本规则的订立、效力、解释、履行及争议解决均适用中华人民共和国法律法规。
    </div>
    <div style="margin-top: 10px; font-size: 14px; line-height: 1.6;">
      本规则最终解释权归悄然声色运营方所有。
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      isLoading: true
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>

<style lang="less" scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  background: no-repeat 0 0;
  background-size: 100% auto;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
body {
  height: auto;
  -webkit-user-select: none;
  user-select: none;
  color: #333;
  background-color: #ffffff;
}
li {
  list-style: none;
  padding: 0.5em 0;
  width: 100%;
}
.tableData {
  width: 100%;
  overflow: auto;
  padding: 10px 15px;
}
table {
  border-collapse: collapse;
  width: 600px;
}
table,
table tr th,
table tr td {
  white-space: nowrap;
}
th,
td {
  padding: 0.5em;
}
#app {
  font-family: -apple-system-font, BlinkMacSystemFont, "Helvetica Neue",
    "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei UI", "Microsoft YaHei",
    Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 0.8em;
}
.right {
  text-align: right;
}
.middle {
  text-align: center;
}
p {
  line-height: 1.6em;
  word-break: break-all;
  padding: 0.4em 0;
}
h3,
h4 {
  padding: 0.6em 0;
  margin-bottom: 0.5em;
}
.layout {
  padding: 1em 4%;
  letter-spacing: 1px;
}
.title {
  font-size: 1.5em;
  font-weight: 700;
  margin-bottom: 1em;
  text-align: center;
}
.sub_list > * {
  padding: 0.6em 0;
}
</style>